import CoreBase from '../../services/engines/CoreBase';

/**
 * JxDialogState — open/close state for one JxForm dialog. Plain class, NOT a hook — the
 * component only owns a repaint trigger (paint, no logic). One instance per dialog, created
 * once via useState(() => new JxDialogState(...)) — lazy initializer, see Development.Patterns
 * #11 (rk=afd0dd40-b97f-4b9e-b4b2-4a8870008ea5).
 *
 * IMPORTANT: call dlg.setRepaint(repaint) at the top of every render so _repaint stays fresh.
 * The lazy initializer captures the repaint function from the first render — without this call
 * it goes stale after F5 or re-mount.
 *
 * @param {() => void} repaint - forces the owning component to re-render
 * @param {{ focusFieldId?: string, onSave?: function }} [config]
 */
export default class JxDialogState extends CoreBase {
    constructor(repaint, { focusFieldId, onSave } = {}) {
        super();

        this._repaint = repaint;
        this.focusFieldId = focusFieldId;
        this.onSave = onSave;
        this.open = false;
    }

    /**
     * Keep _repaint fresh — call at the top of every render.
     * @param {() => void} repaint
     */
    setRepaint = (repaint) => {
        this._repaint = repaint;
    };

    openDlg = () => {
        this.open = true;

        this._repaint();
    };

    closeDlg = () => {
        this.open = false;
        this._repaint();
    };

    handleClose = (mode, inputs) => {
        this.closeDlg();
        if (mode === -1) return;
        this.onSave?.(inputs);
    };
}
